<label class="component-field-input-checkmark show">
	<section class="check-section-body">
		<div #optionsContainer>
			@for (option of options; track option) {
				<label class="check-template flex show" for="{{ option.id }}" [class.disabled]="isDisabled">
					<input
						type="checkbox"
						class="check-field"
						[disabled]="isDisabled"
						name="{{ option.id }}"
						id="{{ option.id }}"
						[checked]="isCheckedItens"
						(click)="selectOption($event, option)"
					/>
					<span class="overflow-control-indicator"></span>
				</label>
			}
		</div>
		<div class="check-focus-marker">&nbsp;</div>
	</section>
</label>
